import { TableEmptyState } from '@practium/ui';
import type { AreaDTO } from '../../../types';
import { CULTURE_LABELS, IRRIGATION_LABELS } from '../../../constants/properties.constants';
import styles from '../PropertiesTable.module.css';

export interface AreaTableItem extends AreaDTO {
	sectorCount: number;
}

interface AreaTableProps {
	areas: AreaTableItem[];
	propertyName?: string;
	onRowClick?: (id: string) => void;
}

export const AreaTable = ({ areas, propertyName, onRowClick }: AreaTableProps) => {
	if (areas.length === 0) {
		return (
			<TableEmptyState
				title="Nenhuma área encontrada"
				subtitle="Adicione uma área à propriedade para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome</th>
						<th>Propriedade</th>
						<th>Cultura</th>
						<th>Irrigação</th>
						<th>Qtd. Setores</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{areas.map((item) => (
						<tr
							key={item._id}
							onClick={() => item._id && onRowClick?.(item._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{propertyName || '—'}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{CULTURE_LABELS[item.culture] ?? '—'}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>
									{IRRIGATION_LABELS[item.irrigation] ?? '—'}
								</span>
							</td>
							<td>
								<span className={styles.cellNumber}>{item.sectorCount}</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
